// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { stimulusApplication as application } from "packages/web"

import Connect__AgreementController from "./connect/agreement_controller"
application.register("connect--agreement", Connect__AgreementController)

import Connect__ExpressCheckoutController from "./connect/express_checkout_controller"
application.register("connect--express-checkout", Connect__ExpressCheckoutController)

import Connect__PaymentOptionsController from "./connect/payment_options_controller"
application.register("connect--payment-options", Connect__PaymentOptionsController)

import Connect__PayLaterTokenController from "./connect/pay_later_token_controller"
application.register("connect--pay-later-token", Connect__PayLaterTokenController)

import Connect__PaymentInterestController from "./connect/payment_interest_controller"
application.register("connect--payment-interest", Connect__PaymentInterestController)

import Connect__PaymentPlanInterestController from "./connect/payment_plan_interest_controller"
application.register("connect--payment-plan-interest", Connect__PaymentPlanInterestController)
